module.exports = __webpack_public_path__ + "static/img/error_correction.png";